import { render } from "./OEMswiper.vue?vue&type=template&id=86d1b804"
import script from "./OEMswiper.vue?vue&type=script&lang=js"
export * from "./OEMswiper.vue?vue&type=script&lang=js"

import "./OEMswiper.vue?vue&type=style&index=0&id=86d1b804&lang=css"
script.render = render

export default script